<template>
    <div class="componentRoot">
        <!-- <ButtonRowVue>
            <template v-slot:leftSide>
                <v-col :cols="searchBarCols" class="pr-2">
                    <v-card flat style="display: flex; align-items: center; " class="pl-4">
                        <h2>{{ $t("routes.calendar") }}</h2>
                    </v-card>
                </v-col>
            </template>
        </ButtonRowVue> -->

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card class="pa-4" flat>
                        <TimeTableParentVue :startDate="activeDate" :readonly="false" />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
import TimeTableParentVue from "../../../components/calendar/TimeTableParent.vue";

export default {
    name: "calendarRoot",

    props: [
    ],
    emits: ["refetch"],

    data() {
        return {
            loading: false,
            refreshTimeTable: 0,
            showHoliday: true,
            activeDate: undefined
        };
    },

    components: {
        TimeTableParentVue
    },

    watch: {

    },

    computed: {
    },

    methods: {
        setLoading(val) {
            this.loading = val
        }
    },

    mounted(){
        this.activeDate = localStorage.getItem("date")
    }
};
</script>
